import { DPNUser } from './user.model';
import { CountryName } from '@shared/models/country.model';

export class Account extends DPNUser {
  public country: CountryName;
  public jobTitle: string;
  public roles: Roles[];
  public countryCode: string;
  public showStartVideo: boolean;

  get isAdmin() {
    return this.roles.includes(Roles.Admin);
  }
}

export enum Roles {
  Default = 0,
  Admin = 1
}
